import { replace } from 'lodash';
import numeral from 'numeral';

export function fCurrency(number: string | number | undefined | null, truncateDecimals = false) {
  if (number === null || number === undefined) {
    return '($0,0)';
  }

  if (truncateDecimals) {
    return numeral(number).format('($0,0)');
  }

  return numeral(number).format(Number.isInteger(number) ? '($0,0)' : '($0,0.00)');
}

export function fCurrencyForPledgingGrid(number: number) {
  const isNegative = number < 0;
  const formattedNumber = numeral(Math.abs(number)).format(Number.isInteger(number) ? '$0,0' : '$0,0.00');
  return isNegative ? `+${formattedNumber}` : formattedNumber;
}

export function fPercent(number: number) {
  return numeral(number / 100).format(Number(number) < 0 ? '(0.00%)' : '0.00%');
}

export function fPercent1Decimal(number: number) {
  return numeral(number / 100).format(Number(number) < 0 ? '(0.0%)' : '0.0%');
}

export function fNumber(number: string | number) {
  return numeral(number).format();
}

export function fShortenNumber(number: string | number) {
  return replace(numeral(number).format('0.00a'), '.00', '');
}

export function fData(number: string | number) {
  return numeral(number).format('0.0 b');
}

export function fDecimalNumber(value: string) {
  const lengthOfDecimals = value.includes('.') ? value.split('.')[1]?.length : 0;
  return numeral(value).format(lengthOfDecimals > 0 ? `(0.${'0'.repeat(lengthOfDecimals)})` : '(0)');
}

export const format8Decimals = (value?: number) => (value != null ? value.toFixed(8) : '');
export const format3Decimals = (value?: number) => (value != null ? value.toFixed(3) : '');
export const format2Decimals = (value?: number | null) => (value ? value.toFixed(2) : '');
export const format1Decimal = (value?: number) => (value != null ? value.toFixed(1) : '');
export const formatAlphanumeric = (value?: any) => (value != null ? value.toString() : '');
